import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const DeleteEndpoint = ApiEndpoints.disclosure.Delete;
const listEndpoint = ApiEndpoints.disclosure.List;
const disclosureEditPath = "edit-disclosure";
const tableHeader = ["Branch"];
const tbody = ["name"];

export default function DisclosureListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
        const response = await ApiRequest("GET", listEndpoint);
        const result = response.data;
        const formattedData = result.map((item) => ({
        ...item,
        name: item.branch?.map((b) => b.name).join(" / ")
        }));

        setData(formattedData);
    } catch (error) {
        console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  
  const handleDelete = async (id) => {
      const payload = { id };
      try {
        const response = await ApiRequest("POST", DeleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'Mandatory Disclosure',
      user: 'Admin',
      innerpage: 'Mandatory Disclosure'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-disclosure">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={disclosureEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
